import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExternalDocuments = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6 5V3.5A1.5 1.5 0 0 1 7.5 2H13a1.5 1.5 0 0 1 1.5 1.5v8A1.5 1.5 0 0 1 13 13h-1.5",
		stroke: "currentColor",
		strokeWidth: 1.3,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 3.5,
		y: 5,
		width: 8,
		height: 11,
		rx: 1.5,
		stroke: "currentColor",
		strokeWidth: 1.3
	})]
});
export { SvgExternalDocuments as ReactComponent };
